// src/features/infoscreens/pages/InfoscreenShowPage/components/TasksListView.jsx
import React from 'react';
import { Box, Typography, Chip, useTheme } from '@mui/material';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { getStateConfig, getPriorityColor } from '../../../../tasks/utils/taskStateUtils';
import DateWithHint from '../../../../../components/common/DateWithHint';
import StaffMember from '../../../../../components/common/StaffMember';

export default function TasksListView({ tasks, onSwitchUser }) {
  const { t } = useTranslation(['tasks']);
  const theme = useTheme();

  return (
    <Box sx={{ width: '100%', overflowX: 'auto' }}>
      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
          backgroundColor: 'background.paper',
        }}
      >
        <thead>
          <tr
            style={{
              borderBottom: '2px solid #ddd',
              backgroundColor: 'background.paper',
            }}
          >
            <th style={{ padding: '16px', textAlign: 'left', fontWeight: 600 }}>
              {t('tasks:labels.title', { defaultValue: 'Title' })}
            </th>
            <th style={{ padding: '16px', textAlign: 'left', fontWeight: 600 }}>
              {t('tasks:labels.status', { defaultValue: 'Status' })}
            </th>
            <th style={{ padding: '16px', textAlign: 'left', fontWeight: 600 }}>
              {t('tasks:labels.priority', { defaultValue: 'Priority' })}
            </th>
            <th style={{ padding: '16px', textAlign: 'left', fontWeight: 600 }}>
              {t('tasks:labels.assignee', { defaultValue: 'Assignee' })}
            </th>
            <th style={{ padding: '16px', textAlign: 'left', fontWeight: 600 }}>
              {t('tasks:labels.assignee', { defaultValue: 'Assignee' })}
            </th>
            <th style={{ padding: '16px', textAlign: 'left', fontWeight: 600 }}>
              {t('tasks:labels.due_date', { defaultValue: 'Due Date' })}
            </th>
          </tr>
        </thead>
        <tbody>
          {tasks.map((task) => {
            const stateConfig = getStateConfig(task.state);
            const priorityColor = getPriorityColor(task.priority);

            return (
              <tr
                key={task.task_id}
                onClick={() => onSwitchUser?.(`/tasks/${task.task_id}`)}
                style={{
                  borderBottom: `1px solid ${theme.palette.divider}`,
                  transition: 'background-color 0.2s',
                  cursor: onSwitchUser ? 'pointer' : 'default',
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = theme.palette.action.hover)
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = 'transparent')
                }
              >
                <td style={{ padding: '16px' }}>
                  <Typography variant="body1" fontWeight="medium">
                    {task.title}
                  </Typography>
                  {task.description && (
                    <Typography variant="body2" color="text.secondary" noWrap maxWidth={"20vw"}>
                      {task.description}
                    </Typography>
                  )}
                </td>
                <td style={{ padding: '16px' }}>
                  <Chip
                    label={stateConfig.label}
                    size="small"
                    color={stateConfig.color}
                    variant="outlined"
                  />
                </td>
                <td style={{ padding: '16px' }}>
                  <Chip
                    label={t(`tasks:priority.${task.priority.toLowerCase()}`)}
                    size="small"
                    color={priorityColor}
                  />
                </td>
                <td style={{ padding: '16px' }}>
                  {task.primary_assignee ? (
                    <StaffMember
                      staffMember={task.primary_assignee}
                      avatarSize={32}
                      imageSize="32x32"
                      nameVariant="body2"
                    />
                  ) : (
                    <Typography variant="body2">-</Typography>
                  )}
                </td>
                <td style={{ padding: '16px' }}>
                  {task.secondary_assignee ? (
                    <StaffMember
                      staffMember={task.secondary_assignee}
                      avatarSize={32}
                      imageSize="32x32"
                      nameVariant="body2"
                    />
                  ) : (
                    <Typography variant="body2">-</Typography>
                  )}
                </td>
                <td style={{ padding: '16px' }}>
                  <DateWithHint
                    date={task.due_date} 
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Box>
  );
}